import { useCallback, useState } from "react";
import useWeb3 from "../useWeb3";
import { wdtcContract } from "../../utils/contractHelpers";
import { useWeb3React } from "../useWagmiCompat";
import Environment from "../../utils/Environment";

const ApproveTplWbtc1 = () => {

  const [balance, setBalance] = useState(null)
  const { account } = useWeb3React();
  const web3 = useWeb3();
  const tokenAddress = Environment.wbtc;
  const tokenAddress1 = Environment.instituson;
  const contract = wdtcContract(tokenAddress, web3);


  const approveTplWbtc1 = useCallback(
    async (amount) => {
      try {
        let nd =amount*10**8
        // let gasPrice = await web3.eth.getGasPrice();
        // gasPrice = parseInt(gasPrice) + 5000000000;
        const gas = await contract.methods
          .approve(tokenAddress1, nd.toString())
          .estimateGas({ from: account });
        // let gasPrice = await web3.eth.getGasPrice();
        const details = await contract.methods
          .approve(tokenAddress1, nd.toString())
          .send({
            from: account,
            gas: gas,
            // gasPrice,
          });
        return details;
        // console.log('sdsdss' ,  buy)
        // return details;
      } catch (error) {
        throw error;
      }
    },
    [contract, account,web3]
  );
  return {approveTplwbtc1: approveTplWbtc1};
};
export default ApproveTplWbtc1;